import styled from "styled-components";
import { Grid as UnstyledGrid } from "@progress/kendo-react-grid";

const Grid = styled(UnstyledGrid)`
  font-family: Inter, system-ui;
  font-weight: 400;

  tr td:first-child {
    font-weight: 400;
  }

  .k-pager-numbers-wrap .k-link {
    border-radius: 50%;

    &:focus {
      box-shadow: inset 0 0 0 2px rgba(117, 178, 221, 0.12);
    }

    &:hover {
      background-color: rgba(117, 178, 221, 0.08);
    }
  }
`;

export default Grid;
